import { render, staticRenderFns } from "./menu-info.vue?vue&type=template&id=8a919416&scoped=true&"
import script from "./menu-info.vue?vue&type=script&lang=js&"
export * from "./menu-info.vue?vue&type=script&lang=js&"
import style0 from "./menu-info.vue?vue&type=style&index=0&id=8a919416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a919416",
  null
  
)

export default component.exports